import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ChatAiModule } from '../../pages/chat-ai/chat-ai.module';
import { ChatModalComponent } from './chat-modal.component';

@NgModule({
  declarations: [ChatModalComponent],
  imports: [CommonModule, ChatAiModule],
  exports: [ChatModalComponent],
})
export class ChatModalModule {}
